function LoadingSpinner({ size = 'md' }) {
    return (
        <span className={`loading loading-spinner loading-${size}`}></span>
    )
}

function DotSpinner({ size = 'md' }) {
    return (
        <span className={`loading loading-dots loading-${size}`}></span>
    )
}

function BreathingSpinner({ size = 'md' }) {
    return (
        <span className={`loading loading-ring loading-${size}`}></span>
    )
}

export { LoadingSpinner, DotSpinner, BreathingSpinner }